<div class="services-setup">
  <!-- ======================================================
       Heading
  ======================================================= -->

  <div class="services-heading">
    <div>
      <span class="services-kicker"> Step 2 </span>

      <h3>Match your services</h3>

      <p>
        Link Square appointment services with existing gloget services, create
        missing services in gloget, or create Square services from your existing
        gloget setup.
      </p>
    </div>
  </div>

  <!-- ======================================================
       Messages
  ======================================================= -->

  <div *ngIf="successMessage" class="service-notice service-notice--success">
    {{ successMessage }}
  </div>

  <div *ngIf="errorMessage" class="service-notice service-notice--error">
    {{ errorMessage }}
  </div>

  <!-- ======================================================
       Square services
  ======================================================= -->

  <section class="service-section">
    <div class="service-section__header">
      <div>
        <h4>Square services</h4>

        <p>Connect each Square appointment service to its gloget equivalent.</p>
      </div>

      <span class="count-pill">
        {{ squareServices.length }}
      </span>
    </div>

    <div *ngIf="squareServices.length === 0" class="empty-state">
      No bookable Square services were found.
    </div>

    <div class="service-list">
      <article
        *ngFor="let service of squareServices"
        class="service-card"
        [class.service-card--mapped]="!!service.mapping"
      >
        <!-- Square service -->

        <div class="service-card__main">
          <div class="source-badge source-badge--square">Square</div>

          <div class="service-card__identity">
            <div class="service-title-row">
              <h5>
                {{ service.display_name }}
              </h5>

              <span *ngIf="service.mapping" class="mapped-pill">
                ✓ Mapped
              </span>
            </div>

            <p>
              {{ squarePriceLabel(service) }}
            </p>

            <small *ngIf="service.variation_name">
              Variation:
              {{ service.variation_name }}
            </small>
          </div>
        </div>

        <!-- Existing mapping -->

        <div *ngIf="service.mapping" class="mapped-result">
          <div>
            <span> Connected to </span>

            <strong>
              {{ service.mapping.service_name }}
            </strong>
          </div>

          <small>
            {{ service.mapping.salon_name }}
          </small>
        </div>

        <!-- Not mapped -->

        <div *ngIf="!service.mapping" class="service-actions">
          <div class="map-existing">
            <label> Map to existing gloget service </label>

            <div class="map-existing__controls">
              <select
                [(ngModel)]="
                  selectedServiceBySquareVariation[service.variation_id]
                "
              >
                <option value="">Select service</option>

                <option
                  *ngFor="let glogetService of availableServicesFor(service)"
                  [value]="glogetService.id"
                >
                  {{ glogetService.salon.name }}
                  —
                  {{ glogetService.name }}
                </option>
              </select>

              <button
                type="button"
                class="map-button"
                [disabled]="mappingVariationId === service.variation_id"
                (click)="mapExisting(service)"
              >
                {{
                  mappingVariationId === service.variation_id
                    ? "Mapping..."
                    : "Map"
                }}
              </button>
            </div>
          </div>

          <div class="action-divider">
            <span> or </span>
          </div>

          <button
            type="button"
            class="create-button"
            (click)="openCreateInGloget(service)"
          >
            Create new service in gloget
          </button>
        </div>
      </article>
    </div>
  </section>

  <!-- ======================================================
       gloget-only services
  ======================================================= -->

  <section class="service-section">
    <div class="service-section__header">
      <div>
        <h4>gloget-only services</h4>

        <p>
          These services do not currently have a Square appointment service
          mapped to them.
        </p>
      </div>

      <span class="count-pill">
        {{ unmappedGlogetServices.length }}
      </span>
    </div>

    <div
      *ngIf="unmappedGlogetServices.length === 0"
      class="empty-state empty-state--success"
    >
      ✓ All gloget services are connected to Square.
    </div>

    <div class="service-list">
      <article
        *ngFor="let service of unmappedGlogetServices"
        class="service-card"
      >
        <div class="service-card__main">
          <div class="source-badge source-badge--gloget">gloget</div>

          <div class="service-card__identity">
            <h5>
              {{ service.name }}
            </h5>

            <p>
              {{ service.price }}
            </p>

            <small>
              {{ service.salon.name }}
              ·
              {{ service.duration_minutes }}
              min
            </small>
          </div>
        </div>

        <div class="gloget-only-actions">
          <span> No Square service mapped </span>

          <button
            type="button"
            class="create-square-button"
            [disabled]="creatingSquareServiceId === service.id"
            (click)="createInSquare(service)"
          >
            {{
              creatingSquareServiceId === service.id
                ? "Creating..."
                : "Create in Square"
            }}
          </button>
        </div>
      </article>
    </div>
  </section>

  <!-- ======================================================
       Create gloget service modal
  ======================================================= -->

  <div
    *ngIf="showCreateGlogetModal"
    class="modal-backdrop"
    (click)="closeCreateGlogetModal()"
  >
    <div
      class="create-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="
        create-gloget-service-title
      "
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->

      <div class="create-modal__header">
        <div>
          <span class="modal-kicker"> Square → gloget </span>

          <h3
            id="
              create-gloget-service-title
            "
          >
            Create service in gloget
          </h3>

          <p>
            Review the Square service and choose which gloget salon it belongs
            to.
          </p>
        </div>

        <button
          type="button"
          class="modal-close"
          [disabled]="createGlogetSubmitting"
          aria-label="Close"
          (click)="closeCreateGlogetModal()"
        >
          ×
        </button>
      </div>

      <!-- Source -->

      <div *ngIf="selectedSquareService" class="modal-source">
        <span> Square service </span>

        <strong>
          {{ selectedSquareService.display_name }}
        </strong>

        <small>
          {{ squarePriceLabel(selectedSquareService) }}
        </small>
      </div>

      <!-- Error -->

      <div
        *ngIf="createGlogetError"
        class="service-notice service-notice--error modal-error"
      >
        {{ createGlogetError }}
      </div>

      <!-- Form -->

      <div class="modal-form">
        <div class="form-field">
          <label for="service-salon">
            gloget salon
            <span>*</span>
          </label>

          <select
            id="service-salon"
            [(ngModel)]="createGlogetForm.salon_id"
            [disabled]="createGlogetSubmitting"
          >
            <option value="">Select salon</option>

            <option *ngFor="let salon of glogetSalons" [value]="salon.id">
              {{ salon.name }}
            </option>
          </select>
        </div>

        <div class="form-field">
          <label for="service-name">
            Service name
            <span>*</span>
          </label>

          <input
            id="service-name"
            type="text"
            [(ngModel)]="createGlogetForm.name"
            [disabled]="createGlogetSubmitting"
          />
        </div>

        <div class="modal-form__grid">
          <div class="form-field">
            <label for="service-price">
              Price
              <span>*</span>
            </label>

            <input
              id="service-price"
              type="number"
              min="0"
              step="0.01"
              [(ngModel)]="createGlogetForm.price"
              [disabled]="createGlogetSubmitting"
            />
          </div>

          <div class="form-field">
            <label for="service-duration">
              Duration
              <span>*</span>
            </label>

            <div class="duration-input">
              <input
                id="service-duration"
                type="number"
                min="1"
                step="1"
                [(ngModel)]="createGlogetForm.duration_minutes"
                [disabled]="createGlogetSubmitting"
              />

              <span> minutes </span>
            </div>
          </div>
        </div>

        <p class="import-note">
          The service will be created in the selected gloget salon and
          immediately mapped to this Square service.
        </p>
      </div>

      <!-- Footer -->

      <div class="create-modal__footer">
        <button
          type="button"
          class="modal-cancel-button"
          [disabled]="createGlogetSubmitting"
          (click)="closeCreateGlogetModal()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="modal-submit-button"
          [disabled]="createGlogetSubmitting"
          (click)="submitCreateInGloget()"
        >
          <span *ngIf="createGlogetSubmitting" class="modal-spinner"></span>

          {{ createGlogetSubmitting ? "Creating..." : "Create & map service" }}
        </button>
      </div>
    </div>
  </div>
</div>
